export const requestIdleCallback = (callback, timeout = 0) => {
  if (window.requestIdleCallback) {
    const callbackId = window.requestIdleCallback(callback, {
      timeout
    });
    return () => window.cancelIdleCallback(callbackId);
  }
  const timeoutId = window.setTimeout(callback, timeout);
  return () => window.clearTimeout(timeoutId);
};